<script>
    import { tick } from "svelte";

    export let id;
    export let label;
    export let value;
    export let disabled = null;
    export let required = null;

    const KEYBOARD = {
        BACKSPACE: 8,
        DELETE: 46,
    };

    const handleKeyDown = (e) => {
        if (e.key == "Backspace" || e.key =="Delete" || e.key == "ArrowLeft" || e.key == "ArrowRight" || e.key === "Enter") {
          return true;
        }
    }

    const handleKeyPress = (e) => {
        if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
          return true;
        }

        var digits = e.target.value.match(/\d/g);
        var hasDash = e.target.value.match(/-/);
        var hasSpace = e.target.value.match(/\s/);

        if (e.key.match(/\d/) && (!digits || digits.length < 10)) {
            return true;
        } else if (!hasDash && !hasSpace && (e.key == "-" || e.key.match(/\s/))) {
            if (e.target.selectionStart === 3) {
                return true;
            }
        }

        e.preventDefault();
        return false;
    }

    const handlePaste = (e) => {
        e.preventDefault();
        return false;
    }

</script>


{#if label}<label for="{id}" class:isrequired="{required}">{label}</label>{/if}
<div class="acc-wrap">
    <input {required}
           {disabled}
           type="text"
           bind:value
           id="{id}"
           minlength="4"
           maxlength="9"
           class="form-control acc"
           on:keydown="{handleKeyDown}"
           on:keypress="{handleKeyPress}"
           on:paste="{handlePaste}"
           data-bouncer-target=".acc-error"
           data-validator="accnumber" />
</div>
<div class="acc-error"></div>

<style>

    .acc-wrap {
        display: flex;
        width: 220px;
    }

    .acc {
        width: 100%;
    }

</style>
